module.exports = __webpack_public_path__ + "static/media/chip-1.4bd20e1d.jpg";